<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Templates Cruzadas</h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-crossword-template-new' }"
        >
          Novo template
        </router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Templates Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <puzzle-list-table
                :puzzles="puzzle.list"
                eventName="Delete:Puzzle"
              >
                <div slot="actions" slot-scope="{ puzzleId, puzzleName }">
                  <d-link
                    :to="{
                      name: 'admin-crossword-template-edit',
                      params: { puzzleId },
                    }"
                  >
                    {{ puzzleName }}
                  </d-link>
                </div>
              </puzzle-list-table>
            </div>
            <pagination
              :total-items="puzzle.total_items"
              :pagination.sync="pagination"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import PuzzleListTable from '_shared/PuzzleListTable.vue';

export default {
  name: 'puzzle-template-list',
  components: {
    Pagination,
    PuzzleListTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        slug: 'palavra-cruzadas',
        templates: true,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    puzzle() {
      const { puzzleList } = this.$store.state.puzzle;
      if (puzzleList && puzzleList.list.length) {
        return puzzleList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {},
  methods: {
    ...mapActions(['setToggle', 'getPuzzleList']),
    getList() {
      this.getPuzzleList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>
